import {
    actionGetEmailsRequest,
    actionGetEmailsSuccess,
    actionGetEmailsFailure,
    actionDeleteEmailsRequest,
    actionDeleteEmailsSuccess,
    actionDeleteEmailsFailure,
    actionPutEmailsRequest,
    actionPutEmailsSuccess,
    actionPutEmailsFailure,
    actionPostEmailsRequest,
    actionPostEmailsSuccess,
    actionPostEmailsFailure,
} from './actions';

import {
    resourcesGetEmails,
    resourcesDeleteEmails,
    resourcesPutEmails,
    resourcesPostEmails,
} from './resources';

export const thunksGetEmails = () => {
    return (dispatch, getState) => {
        const token = getState().getIn(['auth', 'user', 'token']);

        dispatch(actionGetEmailsRequest());
        return resourcesGetEmails(token)
            .then((response) => {
                dispatch(actionGetEmailsSuccess(response.data));
            })
            .catch((error) => {
                dispatch(actionGetEmailsFailure(error));
            });
    };
};

export const thunksDeleteEmails = (branchid, emailid) => {
    return (dispatch, getState) => {
        const token = getState().getIn(['auth', 'user', 'token']);

        dispatch(actionDeleteEmailsRequest());
        return resourcesDeleteEmails(token, branchid, emailid)
            .then((response) => {
                dispatch(actionDeleteEmailsSuccess(response.data));
            })
            .catch((error) => {
                dispatch(actionDeleteEmailsFailure(error));
            });
    };
};

export const thunksPutEmails = (branchid, emailid, body) => {
    return (dispatch, getState) => {
        const token = getState().getIn(['auth', 'user', 'token']);

        console.log('thunksPutEmails', branchid, emailid, body);

        dispatch(actionPutEmailsRequest());
        return resourcesPutEmails(token, branchid, emailid, body)
            .then((response) => {
                dispatch(actionPutEmailsSuccess(response.data));
            })
            .catch((error) => {
                dispatch(actionPutEmailsFailure(error));
            });
    };
};

export const thunksPostEmails = (branchid, body) => {
    return (dispatch, getState) => {
        const token = getState().getIn(['auth', 'user', 'token']);

        dispatch(actionPostEmailsRequest());
        return resourcesPostEmails(token, branchid, body)
            .then((response) => {
                dispatch(actionPostEmailsSuccess(response.data));
            })
            .catch((error) => {
                dispatch(actionPostEmailsFailure(error));
            });
    };
};
